export default "__VITE_ASSET__CN2eD262__"